.carousel {
  position: relative;
}

.carouselViewport {
  overflow: hidden;
}

.carouselContainer {
  display: flex;
}

.carouselContainerHorizontal {
  margin-left: calc(var(--cxy-spacing-xsm) * -1);
  flex-direction: row;
}

.carouselContainerVertical {
  margin-top: calc(var(--cxy-spacing-xsm) * -1);
  flex-direction: column;
}

.carouselItem {
  min-width: 0px;
  flex-shrink: 0;
  flex-grow: 0;
  flex-basis: 100%;
}

.carouselItemHorizontal {
  padding-left: var(--cxy-spacing-xsm);
}

.carouselItemVertical {
  padding-top: var(--cxy-spacing-xsm);
}

.carouselControl {
  position: absolute;
  border-radius: 9999px;
  background-color: white;
  color: var(--cxy-color-interactive-primary, #007bff);
  z-index: 10;
  outline: 2px solid transparent;
  outline-offset: var(--cxy-spacing-0);
  border: none;
}

.carouselPreviousButtonHorizontal {
  left: var(--cxy-spacing-xxsm);
  top: 50%;
  transform: translateY(-50%);
}

.carouselNextButtonHorizontal {
  right: var(--cxy-spacing-xxsm);
  top: 50%;
  transform: translateY(-50%);
}

.carouselPreviousButtonVertical {
  top: var(--cxy-spacing-xxsm);
  left: 50%;
  transform: translateX(-50%) rotate(90deg);
}

.carouselNextButtonVertical {
  bottom: var(--cxy-spacing-xxsm);
  left: 50%;
  transform: translateX(-50%) rotate(90deg);
}

.controlsOutside {
  & .carouselPreviousButtonHorizontal {
    left: calc(var(--cxy-spacing-lg) * -1);
  }
  & .carouselNextButtonHorizontal {
    right: calc(var(--cxy-spacing-lg) * -1);
  }
  & .carouselPreviousButtonVertical {
    top: calc(var(--cxy-spacing-lg) * -1);
  }
  & .carouselNextButtonVertical {
    bottom: calc(var(--cxy-spacing-lg) * -1);
  }
}

.carouselControlIcon {
  height: var(--cxy-spacing-xsm);
  width: var(--cxy-spacing-xsm);
}

.srOnly {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}

.edgeFade {
  --_fade-color: var(--cxy-carousel-fade-color, var(--cxy-color-content-on-inverse, #fff));

  &::before,
  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: var(--cxy-carousel-fade-size, 32px);
    pointer-events: none;
    z-index: 1;
    opacity: 0;
    transition: opacity var(--cxy-carousel-fade-transition, 0s);
  }

  &::before {
    left: 0;
    background: linear-gradient(to right, var(--_fade-color), transparent);
  }

  &::after {
    right: 0;
    background: linear-gradient(to left, var(--_fade-color), transparent);
  }

  &[data-can-scroll-prev='true']::before,
  &[data-can-scroll-next='true']::after {
    opacity: 1;
  }
}
